// JsFromRoutes CacheKey 20903fc47c361ae74de069d302f3eae4
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@js-from-routes/client'

export default {
  update: /* #__PURE__ */ definePathHelper('patch', '/:account_id/help/settings'),
}
